const RoundFiji = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
      <g>
        <path
          fill="#3ECBF8"
          d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z"
        />
        <path
          fill="#1A47B8"
          d="M15.9998 7.6521V13.0485L10.4346 7.6521H15.9998ZM8.34797 15.9999H13.0487L8.34797 9.73901 7.65234 14.6086 8.34797 15.9999Z"
        />
        <path
          fill="white"
          d="M15.957 16.0001H15.9998C15.9998 15.9857 15.9998 15.9717 15.9998 15.9573C15.9856 15.9716 15.9713 15.9858 15.957 16.0001Z"
        />
        <path
          fill="white"
          d="M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.162 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0486 16H15.9573C15.9716 15.9858 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z"
        />
        <path
          fill="#F93939"
          d="M8.09466 2.08691C5.59223 3.51185 3.51185 5.59223 2.08691 8.09466V16H6.26085V6.26098V6.26085H16C16 4.94441 16 3.69029 16 2.08691H8.09466Z"
        />
        <path
          fill="#F93939"
          d="M15.9998 14.0325L10.3152 8.3479H8.34766V8.34803L15.9997 16H15.9998C15.9998 16 15.9998 14.6433 15.9998 14.0325Z"
        />
        <path
          fill="#F3F3F3"
          d="M18.0869 10.4348V15.9999C18.0869 19.7274 22.9565 20.8695 22.9565 20.8695C22.9565 20.8695 27.826 19.7274 27.826 15.9999V10.4348L22.9565 9.04346L18.0869 10.4348Z"
        />
        <path
          fill="#F93939"
          d="M27.826 10.4348V8.3479H18.0869V10.4348H22.2607V14.6088H18.0869V16V16.0002L22.2607 16.0002V20.6563C22.6806 20.8048 22.9565 20.8697 22.9565 20.8697C22.9565 20.8697 23.2322 20.8049 23.652 20.6563V16.0002H27.826V16V14.6088H23.652V10.4348H27.826V10.4348Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="white" d="M0 0H32V32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RoundFiji;
